var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import { Toast } from "@uigovpe/components";
import { ToastContext } from "../../contexts/toast-context";
export var ToastProvider = function (_a) {
    var children = _a.children;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var toastRef = useRef(null);
    var show = React.useCallback(function (message) {
        if (toastRef.current) {
            toastRef.current.show(message);
        }
    }, []);
    var clear = React.useCallback(function () {
        if (toastRef.current) {
            toastRef.current.clear();
        }
    }, []);
    var contextValue = React.useMemo(function () { return ({ show: show, clear: clear }); }, [show, clear]);
    return (_jsxs(ToastContext.Provider, __assign({ value: contextValue }, { children: [_jsx(Toast, { ref: toastRef }), children] })));
};
